export const UserActionTypes = {
  SET_LOGGED_IN_STATUS: "SET_LOGGED_IN_STATUS",
  SET_USER_DATA: "SET_USER_DATA",
  SET_AUTH_DATA: "SET_AUTH_DATA",
  SET_IDLE_MODAL: "SET_IDLE_MODAL",
  RESET_USER: "RESET_USER",
};
